import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, Dialog, Toast } from "primereact";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";

import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../Base/Hooks/useForm";
import Loader from "../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../Base/Services/ToastService";
import { ConfigContext } from "../../../Base/Context/ConfigContext/ConfigContext";
import { baseLang } from "../../../Base/Lang/BaseLang";
import { getLabel } from "../../../Base/Services/Language/LanguageService";

import { getEstadosCotizaciones } from "../../../API/Global/Status/StatusRequests";
import { EditarCalibre, EditarCross, EditarEfecto, EditarFibra, EditarLoster, EditarRecycled, EditarType, EditarTypesC, EditarTypesP, getStyleCategory, GuardarCalibre, GuardarCross, GuardarEfecto, GuardarFibra, GuardarLoster, GuardarRecycled, GuardarType, GuardarTypesC, GuardarTypesP } from "../../../API/Desarrollo/DesarrolloRequest";

const MaestrosCRUD = ({
  dialog,
  setDialog,
  selected,
  setSelected,
  modo,
  getInfo,
  IdCrud
}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [stylesCategory, setStylesCategory] = useState([]);
  const [titleAg, setTitleAg] = useState('');
  const [titleEd, setTitleEd] = useState('');

  const initialValues = {
    IdStatus: selected ? selected?.IdStatus : 3706,
    Description: '',
  };


  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);


    const estadosTempo = await getEstadosCotizaciones();
    setEstados(estadosTempo);
    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === selected?.IdStatus);

    const stylesTempo = await getStyleCategory();
    setStylesCategory(stylesTempo.filter(i=> i.IdStyleCategory === 1 || i.IdStyleCategory === 2));


    let styleInicial
    if(IdCrud === 2){
        styleInicial = modo === "Crear" ? null : stylesTempo.find((e) => e.IdStyleCategory === selected?.IdStyeleCategory)
    }else{
        styleInicial = modo === "Crear" ? null : stylesTempo.find((e) => e.IdStyleCategory === selected?.IdStyleCategory)
    }

    switch (IdCrud) {
        case 1:
            setValues({
                ...selected,
                IdCalibre: selected ? selected?.IdCalibre : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus,
                StyleCategory: styleInicial,
                IdStyleCategory: styleInicial?.IdStyleCategory,
            });
          break;
        case 2:
            setValues({
                ...selected,
                IdType: selected ? selected?.IdType : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus,
                StyleCategory: styleInicial,
                IdStyleCategory: styleInicial?.IdStyleCategory,
            });
          break;
        case 3:
            setValues({
                ...selected,
                IdEfecto: selected ? selected?.IdEfecto : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus,
            });
          break;
        case 4:
            setValues({
                ...selected,
                IdFibra: selected ? selected?.IdFibra : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus,
            });
          break;
        case 5:
            setValues({
                ...selected,
                IdTypeCotton: selected ? selected?.IdTypeCotton : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus,
            });
          break;
        case 6:
            setValues({
                ...selected,
                IdLoster: selected ? selected?.IdLoster : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus,
            });
          break;
        case 7:
            setValues({
                ...selected,
                IdRecycle: selected ? selected?.IdRecycle : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus,
                StyleCategory: styleInicial,
                IdStyleCategory: styleInicial?.IdStyleCategory,
            });
          break;
        case 8:
            setValues({
                ...selected,
                IdCross: selected ? selected?.IdCross : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus,
            });
        case 9:
            setValues({
                ...selected,
                IdTypePoly: selected ? selected?.IdTypePoly : -1,
                Estado: estadoInicial,
                IdStatus: estadoInicial?.IdStatus,
            });
          break;
        default:
          console.warn('Invalid index for dialog');
          break;
    }
    setLoading(false);
  };

  const onHide = () => {
    setDialog(false);
    setSelected(null);
  };

  const verificarInfo = () => {
    let error = {};


    if(IdCrud === 1){
        if (!values?.CalibreInt) {
            error.CalibreInt = true;
            error.error = true;
        }
    }
    if(IdCrud === 2){
        if (!values?.Type) {
            error.Type = true;
            error.error = true;
        }
    }
    if(IdCrud === 1 || IdCrud === 2 || IdCrud === 7 || IdCrud === 3 || IdCrud === 4){
        if (!values.StyleCategory && (!values.IdStyleCategory || !values?.StyleCategory?.IdStyleCategory)) {
            error.IdStyleCategory = true;
            error.error = true;
        }
    }

    if(IdCrud === 3){
        if (!values?.Efecto) {
            error.Efecto = true;
            error.error = true;
        }
    }
    if(IdCrud === 4){
        if (!values?.Fiber) {
            error.Fiber = true;
            error.error = true;
        }
    }
    if(IdCrud === 5){
        if (!values?.TypeCotton) {
            error.TypeCotton = true;
            error.error = true;
        }
    }
    if(IdCrud === 6){
        if (!values?.Loster) {
            error.Loster = true;
            error.error = true;
        }
    }
    if(IdCrud === 7){
        if (!values?.Recycled) {
            error.Recycled = true;
            error.error = true;
        }
    }
    if(IdCrud === 8){
        if (!values?.CrossSection) {
            error.CrossSection = true;
            error.error = true;
        }
    }
    if(IdCrud === 9){
        if (!values?.TypePoly) {
            error.TypePoly = true;
            error.error = true;
        }
    }
    if (!values.Estado && (!values.IdStatus || !values?.Estado?.IdStatus)) {
        error.IdStatus = true;
        error.error = true;
    }

    
    setError(error);
    return error;
  };

  const agregarDatos = async () => {
    const e = verificarInfo();
    if (!e.error) {

        setLoading(true);
        let respuesta
        switch (IdCrud) {
            case 1:
                const DatosCalibre = {
                    IdCalibre: values?.IdCalibre,
                    CalibreInt: values?.CalibreInt,
                    Calibre: (values?.CalibreInt)?.toString(),
                    Description: values?.Description,
                    IdStyleCategory: values?.StyleCategory?.IdStyleCategory || values?.IdStyleCategory,
                    IdStatus: values?.Estado?.IdStatus,
                    IdUserCreate: userAuth?.idUser,
                    IdUserEdit: userAuth?.idUser,
                };
                if(DatosCalibre?.IdCalibre > 0){
                    respuesta = await EditarCalibre(DatosCalibre)
                }else{
                    respuesta = await GuardarCalibre(DatosCalibre)
                }

              break;
            case 2:
                const DatosType = {
                    IdType: values?.IdType,
                    Type: values?.Type,
                    Description: values?.Description,
                    IdStyeleCategory: values?.StyleCategory?.IdStyleCategory || values?.IdStyeleCategory,
                    IdStatus: values?.Estado?.IdStatus,
                    IdUserCreate: userAuth?.idUser,
                    IdUserEdit: userAuth?.idUser,
                };

                if(DatosType?.IdType > 0){
                    respuesta = await EditarType(DatosType)
                }else{
                    respuesta = await GuardarType(DatosType)
                }
              break;
            case 3:
                const DatosEfecto = {
                    IdEfecto: values?.IdEfecto,
                    Efecto: values?.Efecto,
                    Description: values?.Description,
                    IdStyleCategory: values?.StyleCategory?.IdStyleCategory || values?.IdStyleCategory,
                    IdStatus: values?.Estado?.IdStatus,
                    IdUserCreate: userAuth?.idUser,
                    IdUserEdit: userAuth?.idUser,
                };

                if(DatosEfecto?.IdEfecto > 0){
                    respuesta = await EditarEfecto(DatosEfecto)
                }else{
                    respuesta = await GuardarEfecto(DatosEfecto)
                }
              break;
            case 4:
                const DatosFibra = {
                    IdFibra: values?.IdFibra,
                    Fiber: values?.Fiber,
                    Description: values?.Description,
                    IdStatus: values?.Estado?.IdStatus,
                    IdStyleCategory: values?.StyleCategory?.IdStyleCategory || values?.IdStyleCategory,
                    IdUserCreate: userAuth?.idUser,
                    IdUserEdit: userAuth?.idUser,
                };

                if(DatosFibra?.IdFibra > 0){
                    respuesta = await EditarFibra(DatosFibra)
                }else{
                    respuesta = await GuardarFibra(DatosFibra)
                }
              break;
            case 5:
                const DatosTypesC = {
                    IdTypeCotton: values?.IdTypeCotton,
                    TypeCotton: values?.TypeCotton,
                    Description: values?.Description,
                    IdStatus: values?.Estado?.IdStatus,
                    IdStyleCategory: values?.StyleCategory?.IdStyleCategory || values?.IdStyleCategory,
                    IdUserCreate: userAuth?.idUser,
                    IdUserEdit: userAuth?.idUser,
                };

                if(DatosTypesC?.IdTypeCotton > 0){
                    respuesta = await EditarTypesC(DatosTypesC)
                }else{
                    respuesta = await GuardarTypesC(DatosTypesC)
                }
              break;
            case 6:
                const DatosLoster = {
                    IdLoster: values?.IdLoster,
                    Loster: values?.Loster,
                    Description: values?.Description,
                    IdStatus: values?.Estado?.IdStatus,
                    IdUserCreate: userAuth?.idUser,
                    IdUserEdit: userAuth?.idUser,
                };
                if(DatosLoster?.IdLoster > 0){
                    respuesta = await EditarLoster(DatosLoster)
                }else{
                    respuesta = await GuardarLoster(DatosLoster)
                }
              break;
            case 7:
                const DatosRecycled = {
                    IdRecycle: values?.IdRecycle,
                    Recycled: values?.Recycled,
                    Description: values?.Description,
                    IdStatus: values?.Estado?.IdStatus,
                    IdUserCreate: userAuth?.idUser,
                    IdUserEdit: userAuth?.idUser,
                    IdStyleCategory: values?.StyleCategory?.IdStyleCategory || values?.IdStyleCategory,
                };
                
                if(DatosRecycled?.IdRecycle > 0){
                    respuesta = await EditarRecycled(DatosRecycled)
                }else{
                    respuesta = await GuardarRecycled(DatosRecycled)
                }
              break;
            case 8:
                const DatosCross = {
                    IdCross: values?.IdCross,
                    CrossSection: values?.CrossSection,
                    Description: values?.Description,
                    IdStatus: values?.Estado?.IdStatus,
                    IdUserCreate: userAuth?.idUser,
                    IdUserEdit: userAuth?.idUser,
                };

                if(DatosCross?.IdCross > 0){
                    respuesta = await EditarCross(DatosCross)
                }else{
                    respuesta = await GuardarCross(DatosCross)
                }
              break;
            case 9:
            const DatosTypesS = {
                IdTypePoly: values?.IdTypePoly,
                TypePoly: values?.TypePoly,
                Description: values?.Description,
                IdStatus: values?.Estado?.IdStatus,
                IdUserCreate: userAuth?.idUser,
                IdUserEdit: userAuth?.idUser,
            };

            if(DatosTypesS?.IdTypePoly > 0){
                respuesta = await EditarTypesP(DatosTypesS)
            }else{
                respuesta = await GuardarTypesP(DatosTypesS)
            }
            break;
            default:
              console.warn('Invalid index for dialog');
              break;
        }

        if (respuesta[0].ESTADO !== -1) {
            toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
            setTimeout(() => {
              onHide();
              setLoading(false);
              getInfo();
            }, 1500);
        } else {
            toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
            setLoading(false);
        }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label={getLabel(baseLang, "cancelar", config.language)}
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? `${getLabel(baseLang, "btnGuardar", config.language)}` : `${getLabel(baseLang, "btnEditar", config.language)}`}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarDatos}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (dialog) {
        switch (IdCrud) {
            case 1:
              setTitleAg(getLabel(baseLang, "Agregar Calibre", config.language))
              setTitleEd(getLabel(baseLang, "Editar Calibre", config.language))
              break;
            case 2:
                setTitleAg(getLabel(baseLang, "Agregar Spinning", config.language))
                setTitleEd(getLabel(baseLang, "Editar Spinning", config.language))
              break;
            case 3:
                setTitleEd(getLabel(baseLang, "Editar Efecto", config.language))
                setTitleAg(getLabel(baseLang, "Agregar Efecto", config.language))
              break;
            case 4:
                setTitleEd(getLabel(baseLang, "Editar Fibra", config.language))
                setTitleAg(getLabel(baseLang, "Agregar Fibra", config.language))
              break;
            case 5:
                setTitleEd(getLabel(baseLang, "Editar Composición de Algodón", config.language))
                setTitleAg(getLabel(baseLang, "Agregar Composición de Algodón", config.language))
              break;
            case 6:
                setTitleEd(getLabel(baseLang, "Editar Loster", config.language))
                setTitleAg(getLabel(baseLang, "Agregar Loster", config.language))
              break;
            case 7:
                setTitleEd(getLabel(baseLang, "Editar Reciclado", config.language))
                setTitleAg(getLabel(baseLang, "Agregar Reciclado", config.language))
              break;
            case 8:
                setTitleEd(getLabel(baseLang, "Editar Cross Section", config.language))
                setTitleAg(getLabel(baseLang, "Agregar Cross Section", config.language))
            case 9:
                setTitleEd(getLabel(baseLang, "Editar Type Poly", config.language))
                setTitleAg(getLabel(baseLang, "Agregar Type Poly", config.language))
              break;
            default:
              console.warn('Invalid index for dialog');
              break;
        }
      getValoresIniciales();
    }
  }, [dialog]);

  const dialogTitle = modo === "Crear" ? titleAg : titleEd;

  return (
    <div>
      <Dialog
        visible={dialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <Toast ref={toast} style={{ zIndex: 50000 }} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
            <div className="d-flex align-items-center mx-5">
                <h2>{dialogTitle}</h2>
            </div>

            {IdCrud === 1 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputNumber
                                    name="CalibreInt"
                                    value={values?.CalibreInt}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.CalibreInt ? "p-invalid" : ""}
                                />
                                <label htmlFor="CalibreInt">Calibre</label>
                            </span>
                        </div>

                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                                <AutoCompleteDropdown
                                    name={"StyleCategory"}
                                    value={values.StyleCategory}
                                    items={stylesCategory}
                                    field={"StyleCategory"}
                                    label={getLabel(baseLang, "estilo", config.language)}
                                    handleInputChange={handleInputChange}
                                    className={error.IdStyleCategory ? "p-invalid" : ""}
                                />
                            </span>
                        </div>
                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>

                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                            <InputText
                                name="Description"
                                value={values.Description}
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.Description ? "p-invalid" : ""}
                            />
                            <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {IdCrud === 2 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="Type"
                                    value={values.Type}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.Type ? "p-invalid" : ""}
                                />
                                <label htmlFor="Type">Spinning</label>
                            </span>
                        </div>

                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                                <AutoCompleteDropdown
                                    name={"StyleCategory"}
                                    value={values.StyleCategory}
                                    items={stylesCategory}
                                    field={"StyleCategory"}
                                    label={getLabel(baseLang, "estilo", config.language)}
                                    handleInputChange={handleInputChange}
                                    className={error.IdStyleCategory ? "p-invalid" : ""}
                                />
                            </span>
                        </div>
                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>

                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                            <InputText
                                name="Description"
                                value={values.Description}
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.Description ? "p-invalid" : ""}
                            />
                            <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {IdCrud === 3 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="Efecto"
                                    value={values.Efecto}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.Efecto ? "p-invalid" : ""}
                                />
                                <label htmlFor="Efecto">Efecto</label>
                            </span>
                        </div>

                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                                <AutoCompleteDropdown
                                    name={"StyleCategory"}
                                    value={values.StyleCategory}
                                    items={stylesCategory}
                                    field={"StyleCategory"}
                                    label={getLabel(baseLang, "estilo", config.language)}
                                    handleInputChange={handleInputChange}
                                    className={error.IdStyleCategory ? "p-invalid" : ""}
                                />
                            </span>
                        </div>
                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>

                        
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                            <InputText
                                name="Description"
                                value={values.Description}
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.Description ? "p-invalid" : ""}
                            />
                            <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {IdCrud === 4 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="Fiber"
                                    value={values?.Fiber}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.Fiber ? "p-invalid" : ""}
                                />
                                <label htmlFor="Fiber">Fibra</label>
                            </span>
                        </div>

                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                                <AutoCompleteDropdown
                                    name={"StyleCategory"}
                                    value={values.StyleCategory}
                                    items={stylesCategory}
                                    field={"StyleCategory"}
                                    label={getLabel(baseLang, "estilo", config.language)}
                                    handleInputChange={handleInputChange}
                                    className={error.IdStyleCategory ? "p-invalid" : ""}
                                />
                            </span>
                        </div>
                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>

                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                            <InputText
                                name="Description"
                                value={values.Description}
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.Description ? "p-invalid" : ""}
                            />
                            <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {IdCrud === 5 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="TypeCotton"
                                    value={values?.TypeCotton}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.TypeCotton ? "p-invalid" : ""}
                                />
                                <label htmlFor="TypeCotton">Composición</label>
                            </span>
                        </div>

                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                                <AutoCompleteDropdown
                                    name={"StyleCategory"}
                                    value={values.StyleCategory}
                                    items={stylesCategory}
                                    field={"StyleCategory"}
                                    label={getLabel(baseLang, "estilo", config.language)}
                                    handleInputChange={handleInputChange}
                                    className={error.IdStyleCategory ? "p-invalid" : ""}
                                />
                            </span>
                        </div>
                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                            <InputText
                                name="Description"
                                value={values.Description}
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.Description ? "p-invalid" : ""}
                            />
                            <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {IdCrud === 6 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="Loster"
                                    value={values?.Loster}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.Loster ? "p-invalid" : ""}
                                />
                                <label htmlFor="Loster">Loster</label>
                            </span>
                        </div>

                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                            <InputText
                                name="Description"
                                value={values.Description}
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.Description ? "p-invalid" : ""}
                            />
                            <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>
                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {IdCrud === 7 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="Recycled"
                                    value={values?.Recycled}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.Recycled ? "p-invalid" : ""}
                                />
                                <label htmlFor="Recycled">Recycled</label>
                            </span>
                        </div>

                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                                <AutoCompleteDropdown
                                    name={"StyleCategory"}
                                    value={values.StyleCategory}
                                    items={stylesCategory}
                                    field={"StyleCategory"}
                                    label={getLabel(baseLang, "estilo", config.language)}
                                    handleInputChange={handleInputChange}
                                    className={error.IdStyleCategory ? "p-invalid" : ""}
                                />
                            </span>
                        </div>
                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>

                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                            <InputText
                                name="Description"
                                value={values.Description}
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.Description ? "p-invalid" : ""}
                            />
                            <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>
                    </div>
                </div>
            )}

            {IdCrud === 8 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="CrossSection"
                                    value={values?.CrossSection}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.CrossSection ? "p-invalid" : ""}
                                />
                                <label htmlFor="CrossSection">Cross Section</label>
                            </span>
                        </div>

                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                            <InputText
                                name="Description"
                                value={values.Description}
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.Description ? "p-invalid" : ""}
                            />
                            <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>
                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>
                    </div>

                </div>
            )}

            {IdCrud === 9 && (            
                <div style={{ width: "100", margin: "auto" }}>
                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                                <InputText
                                    name="TypePoly"
                                    value={values?.TypePoly}
                                    onChange={handleInputChange}
                                    style={{ width: "100%" }}
                                    className={error.TypePoly ? "p-invalid" : ""}
                                />
                                <label htmlFor="TypePoly">Type Poly</label>
                            </span>
                        </div>

                        <div className="field col-6 me-2  mt-2">
                            <span className="p-float-label">
                            <InputText
                                name="Description"
                                value={values.Description}
                                onChange={handleInputChange}
                                style={{ width: "100%" }}
                                className={error.Description ? "p-invalid" : ""}
                            />
                            <label htmlFor="Description">{getLabel(baseLang, "desc", config.language)}</label>
                            </span>
                        </div>
                    </div>

                    <div className="modal__input-contenedor">
                        <div className="field col-6 me-2 mt-2">
                            <span className="p-float-label">
                            <AutoCompleteDropdown
                                name={"Estado"}
                                value={values.Estado}
                                items={estados}
                                field={"StatusName"}
                                label={getLabel(baseLang, "estado", config.language)}
                                handleInputChange={handleInputChange}
                                className={error.IdStatus ? "p-invalid" : ""}
                            />
                            </span>
                        </div>
                    </div>

                </div>
            )}
        </div>
      </Dialog>
    </div>
  );
};

export default MaestrosCRUD;
